/**
 * Environment checks used by the side menu (e.g. Reflector V2 production gating).
 */
export const isProductionEnvironment = (): boolean => {
	const appEnv = (process.env.REACT_APP_ENV || "").toLowerCase();
	const nodeEnv = process.env.NODE_ENV || "";

	if (appEnv === "production") {
		return true;
	}
	if (appEnv === "staging") {
		return false;
	}
	if (nodeEnv === "development") {
		return false;
	}
	return nodeEnv === "production";
};
